import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

interface SelectedCalendarsStore {
    selectedCalendars: ObservableMap<string, string[]>;
}
const selectedCalendarsStoreData: SelectedCalendarsStore = {
    selectedCalendars: new ObservableMap<string, string[]>(),
};

const store = createStore<SelectedCalendarsStore>(
    'selectedCalendarsStore',
    selectedCalendarsStoreData
)();
// todo: rename to getSelectedCalendarsStore
export const selectedCalendarsStore = () => store;
